import { updateBasketItemQuantity } from 'utils/basket';
import { logEvent, queueBasketUpdate } from '../helpers';

export type BasketSetItemEventArg = { code: string, quantity: number };

function isBasketSetProductEvent(e: Event): e is CustomEvent<BasketSetItemEventArg> {
  if ('detail' in e) {
    const detail = e.detail;
    if (detail && typeof detail === 'object') {
      return 'code' in detail && typeof detail.code === 'string' && 'quantity' in detail && typeof detail.quantity === 'number'
    }
  }
  return false;
}

export const handleBasketSetProduct = (e: Event) => {
  if (isBasketSetProductEvent(e)) {
    logEvent('basket:set_product', e.detail);
    return queueBasketUpdate((basket) => {
      const { code, quantity } = e.detail;

      return updateBasketItemQuantity(basket, code, quantity);
    });
  } else {
    console.error('Invalid arguments in basket:set_product event');
  }
};
